import React, {useContext, useEffect, useRef, useState} from "react";
import {useHistory, useParams} from 'react-router-dom';
import {TranslateContext} from "../../context/TranslateContext";
import {getTipoImpExpDatiByIdApi} from "./services/TipiImpExpDatiServices";
import FormModificaTipoImpExpController from "./components/FormModificaTipoImpExpController";
import ModificaTipoImpExpView from "./ModificaTipoImpExpView";

export default function ModificaTipoImpExpController() {
    const {id, idClasse} = useParams()

    const [keyTab, setKeyTab] = useState(0);
    const [tipoImpExp, setTipoImpExp] = useState();

    const {translate} = useContext(TranslateContext);

    const formikRefPrinc = useRef();
    const formikRefFiglio = useRef();
    const history = useHistory();

    var formikRef = formikRefPrinc
    if (keyTab === 'figlio') {
        formikRef = formikRefFiglio
    }

    const getElementoDaModificare = async function () {
        const response = await getTipoImpExpDatiByIdApi(id);
        let val = response.data.data;

        setTipoImpExp(val);

        if (formikRefPrinc.current) {
            formikRefPrinc.current.setFieldValue('id_tipo_imp_exp_dati', val.id_tipo_imp_exp_dati);
            formikRefPrinc.current.setFieldValue('id_classe_tipo_imp_exp', val.id_classe_tipo_imp_exp);
            formikRefPrinc.current.setFieldValue('codice', val.codice);
            formikRefPrinc.current.setFieldValue('descrizione', val.descrizione);
            formikRefPrinc.current.setFieldValue('canc', val.canc);
            formikRefPrinc.current.setFieldValue('id_classe_tipo_imp_exp_madre', val.id_classe_tipo_imp_exp_madre);
        }
    }

    useEffect(() => {
        if (!idClasse && id && id !== '') {
            getElementoDaModificare();
        }
    }, [id, idClasse]);

    const scrollableTabs = [
        {
            title: translate("Organizzazione Principale"),
            content: <FormModificaTipoImpExpController
                id={id}
                idClasse={idClasse}
                history={history}
                formikRef={formikRefPrinc}
                principale={true}
                organizzazione={tipoImpExp}
            />
        },
        {
            title: translate("Organizzazione Figlia"),
            content: <FormModificaTipoImpExpController
                id={id}
                idClasse={idClasse}
                history={history}
                formikRef={formikRefFiglio}
                principale={false}
                organizzazione={tipoImpExp}
            />
        },
    ];

    const bottoniSx = [
        {
            icon: 'fas fa-angle-left',
            command: () => {
                history.goBack();
            }
        }
    ];

    const bottoniDx = [
        {
            label: translate("Salva"),
            icon: "fas fa-save",
            command: () => {
                if (formikRef.current) {
                    formikRef.current.handleSubmit()
                }
            }
        }
    ];

    return (
        <ModificaTipoImpExpView
            translate={translate}
            history={history}
            id={id}
            idClasse={idClasse}
            setKeyTab={setKeyTab}
            tipoImpExp={tipoImpExp}
            keyTab={keyTab}
            scrollableTabs={scrollableTabs}
            formikRefPrinc={formikRefPrinc}
            bottoniSx={bottoniSx}
            bottoniDx={bottoniDx}
        />
    );
}